import React from 'react'

const TransferRefusedIcon = () => (
  <svg
    width='32'
    height='33'
    viewBox='0 0 32 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='16' cy='16.5' r='15.5' stroke='#F96440' />
    <path
      d='M13.3083 18.4114L10.8872 20.8324'
      stroke='#F96440'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.3083 20.8324L10.8872 18.4114'
      stroke='#F96440'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.36621 16.0365V13.0589C9.36621 12.0849 9.96953 11.2123 10.8804 10.8681L17.3998 8.40645C18.4214 8.02167 19.5126 8.77563 19.5126 9.86753V12.4822'
      stroke='#F96440'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.7068 17.7496C19.5991 17.7503 19.5125 17.8378 19.5125 17.9455C19.5125 18.0532 19.5999 18.1406 19.7076 18.1398C19.8153 18.1398 19.9027 18.0524 19.9027 17.9447C19.9027 17.837 19.8153 17.7496 19.7068 17.7496'
      stroke='#F96440'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.5658 23.1341H20.293C21.5808 23.1341 22.6345 22.0804 22.6345 20.7926V14.8227C22.6345 13.5294 21.5863 12.4812 20.293 12.4812H10.9272C10.0647 12.4812 9.36621 13.1797 9.36621 14.0422V16.3103'
      stroke='#F96440'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.0979 23.9147C9.72752 23.9147 7.80518 21.9924 7.80518 19.622C7.80518 17.2517 9.72752 15.3293 12.0979 15.3293C14.469 15.3293 16.3905 17.2517 16.3905 19.622C16.3905 21.9924 14.469 23.9147 12.0979 23.9147'
      stroke='#F96440'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default TransferRefusedIcon
